<template>
  <div class="modal" @mousedown="closeModal">
    <div class="card" style="max-width: 450px">
      <div class="card-header">
        <h1>Publish Form</h1>
        <p>Please select a name for this form. Your current account is: <strong>{{ store.account.name }}</strong></p>
      </div>
      <form class="card-body" @submit.prevent="attemptPublish">
        <div class="form-group">
          <label for="name" class="form-label">Form Name</label>
          <input id="name" type="text" name="name" ref="name" class="form-control" v-model="name"
            placeholder="Health History Form" autocomplete="off" data-lpignore="true" data-form-type="other" />
        </div>
      </form>
      <div class="card-footer">
        <button class="button primary" @click.prevent="attemptPublish">
          <img v-if="pending" src="/loading.svg" alt="Loading" class="loading" />
          <span v-else>Publish Form</span>
        </button>
        <p class="error" v-if="error">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { createForm, updateFormLayout, fetchAccountInfo, store } from "@/api";

export default {
  name: "PublishDraftModal",
  props: {
    rows: Array
  },
  data() {
    return {
      name: "",
      error: "",
      pending: false,
      store
    };
  },
  mounted() {
    this.attemptFetchAccountInfo();

    setTimeout(() => {
      const nameRef = this.$refs.name;
      if (nameRef) nameRef.focus();
    }, 500);
  },
  methods: {
    async attemptFetchAccountInfo() {
      try {
        fetchAccountInfo();
      } catch (err) {
        alert('Failed to fetch account info');
      }
    },
    async attemptPublish() {
      this.error = "";
      if (!this.name) {
        this.error = "Please provide a form name";
        return;
      }

      try {
        this.pending = true;
        const newForm = await createForm(this.name);
        await updateFormLayout(newForm.id, this.rows);
        this.$router.push(`/html-editor/${newForm.id}`);

      } catch (err) {
        console.error("Failed to create new form", err);
        this.error = err.message;
      } finally {
        this.pending = false;
      }
    },
    closeModal(event) {
      if (event.target.className != "modal") {
        return;
      }
      this.$emit("closeModal");
    },
  },
  emits: ["closeModal"],
};
</script>